module.exports = __webpack_public_path__ + "assets/img/truly-puzzle-icon.d2db9604.svg";